// extracted by mini-css-extract-plugin
export default {"icon-default":"KcORni","icon-default__size-m":"InTA9o","icon":"QXaPnT"};